/**
 * SallaInstallHandler.jsx
 * Handles auto-login after Salla App Store installation.
 * Reads ?token=JWT&pwd=PASSWORD from URL, saves token, and triggers auth refresh.
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SallaInstallHandler() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { refreshMe } = useAuth();

  useEffect(() => {
    const token     = searchParams.get("token");
    const installed = searchParams.get("installed");
    const isNew     = searchParams.get("new");
    const pwd       = searchParams.get("pwd");

    if (token) {
      // Save JWT from Salla install redirect
      localStorage.setItem("auth_token", token);
      // Save temp password so OnboardingWelcome can display it
      if (pwd) localStorage.setItem("salla_temp_pwd", pwd);
      // Clean URL but keep installed/new flags
      const clean = new URLSearchParams();
      if (installed) clean.set("installed", installed);
      if (isNew)     clean.set("new", isNew);
      setSearchParams(clean, { replace: true });
      // Refresh auth state
      refreshMe();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null; // Purely behavioral
}
